import React, { useMemo } from 'react';
import { Alert, TextLink } from '@guildeducationinc/recess';
import { clickable } from '@src/analytics';
import { useErrorBanner } from '@src/context/ErrorBannerContext';
import { SALESFORCE_NEW_REQUEST_URL } from '@src/constants';
import { useIsMobile, useIsTablet } from '@src/utilities/screenResizeUtility';
import styles from './ErrorBanner.module.scss';

const ErrorBanner: React.FC = () => {
  const { showErrorBanner, closeErrorBanner } = useErrorBanner();
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();

  const getAnchor = (content: string) => {
    return (
      <TextLink
        className={styles.helpCenterLink}
        label='Contact Support'
        target='_blank'
        rel='noopener, noreferrer'
        onClick={() => {
          clickable({
            product: 'home',
            loggedIn: true,
            tag: 'save_information_error',
            text: 'contact_support',
            type: 'link',
          });
        }}
        href={SALESFORCE_NEW_REQUEST_URL}
      >
        {content}
      </TextLink>
    );
  };

  const alertContent = useMemo(() => {
    if (isMobile || isTablet)
      return (
        <span>
          We had trouble saving your information. Try again or&nbsp;
          {getAnchor('contact Support')}.
        </span>
      );
    return (
      <div className={styles.alertDesktopContainer}>
        <span>We had trouble saving your information. Try again or contact Support.</span>
        {getAnchor('Contact Support')}
      </div>
    );
  }, [isMobile, isTablet]);

  return (
    <div className={styles.container}>
      <Alert
        type='danger'
        display={showErrorBanner}
        handleClose={closeErrorBanner}
        className={styles.accountSaveAlert}
        testid='account-save-error'
      >
        <Alert.Content>{alertContent}</Alert.Content>
      </Alert>
    </div>
  );
};

export default ErrorBanner;
